<script>

import EquipmentSearchField from "../../fragments/EquipmentSearchField.vue";

export default {
    name: "SelectorFilters",
    components: {EquipmentSearchField},
    props: {
        filters: {
            type: Array,
            required: true
        },
        sortRadioButtons: {
            type: Array,
            required: true
        },
        statusRadioButtons: {
            type: Array,
            required: true
        },
        stateLabel: {
            type: String,
            required: true
        },
        //Pas de moteur sur sosh
        searchFiltersDto: {
            type: Object,
            required: false,
            default: undefined
        }
    },
    data() {
        return {
          brandCollapseTitle: "Plus de marques",
          refurbishedBrandCollapseTitle: "Plus de marques"
        }
    },
    computed: {
        filtersSegments() {
            return this.filters.find(filter => filter.id === "segments-filter")
        },
        filtersRefurbishedSegments() {
            return this.filters.find(filter => filter.id === "refurbished-segments-filter")
        },
        filtersPrice() {
            return this.filters.find(filter => filter.id === "price-filter")
        },
        filtersRepairability() {
            return this.filters.find(filter => filter.id === "repairability-filter")
        },
        filtersBrand() {
            return this.filters.find(filter => filter.id === "brand-filter")
        },
        filtersRefurbishedBrand() {
            return this.filters.find(filter => filter.id === "brand-refurbished-filter")
        },
        filtersCompatibility() {
            return this.filters.find(filter => filter.id === "compatibility-filter")
        },
        filtersBonusRecovery() {
            return this.filters.find(filter => filter.id === "bonus-recovery-filter")
        },
        brandsWithMobiles(){
            return this.filtersBrand.checkboxes.filter(checkbox => checkbox.mobilesCount > 0)
        },
        refurbishedBrandsWithMobiles(){
            return this.filtersRefurbishedBrand.checkboxes.filter(checkbox => checkbox.mobilesCount > 0)
        },
        brandsWithNotCollapse() {
            let filtersBrandSize = this.brandsWithMobiles.length - 5
            if (filtersBrandSize > 0)
                return this.brandsWithMobiles.slice(0, 5);
            else return this.brandsWithMobiles;
        },
        brandsWithCollapse() {
            let filtersBrandSize = this.brandsWithMobiles.length - 5
            if (filtersBrandSize > 0)
                return this.brandsWithMobiles.slice(5, this.brandsWithMobiles.length);
            else return [];
        },
        refurbishedBrandsWithNotCollapse() {
            let refurbishedFiltersBrandSize = this.refurbishedBrandsWithMobiles.length - 5
            if (refurbishedFiltersBrandSize > 0)
                return this.refurbishedBrandsWithMobiles.slice(0, 5);
            else return this.refurbishedBrandsWithMobiles;
        },
        refurbishedBrandsWithCollapse() {
            let refurbishedFiltersBrandSize = this.refurbishedBrandsWithMobiles.length - 5
            if (refurbishedFiltersBrandSize > 0)
                return this.refurbishedBrandsWithMobiles.slice(5, this.refurbishedBrandsWithMobiles.length);
            else return [];
        },
        showBrandsFilter(){
            return this.selectedStatusFilter !== "reconditionne"
        },
        showRefurbishedBrandsFilter(){
            return this.selectedStatusFilter !== "neuf"
        },
        selectedStatusFilter() {
            let selectedStatus;
            this.statusRadioButtons.forEach((radiosButton) => {
                if (radiosButton.radioButtonDTO.checked === true) {
                    selectedStatus = radiosButton.radioButtonDTO.id
                }
            });

            return selectedStatus;
        },
    },
    methods: {
        filterHandler: function (filterName, label, isChecked) {
            const state = isChecked ? "_coche" : "_decoche";
            Tms.link({
                category: "selecteur_produit",
                action: stripAccents(label).split(' ').join('_'),
                label: "choix_filtre_" + stripAccents(filterName).split(' ').join('_') + state
            })
            this.$emit('change-check-box', this.getSelectedFilters())
        },
        getSelectedFilters: function () {
            let selectedFilters = {};
            this.filters.forEach((filter) => {
                const selectedCheckboxes = filter.checkboxes.filter(checkbox => checkbox.isChecked);
                selectedFilters[filter.id] = selectedCheckboxes.map(selectedCheckbox => {
                   return {id: selectedCheckbox.id, ranges: this.getSelectedRanges(selectedCheckbox)}
                });

            });
            return selectedFilters;
        },
        getSelectedRanges: function (brand) {
            if (brand.ranges) {
                return brand.ranges.filter((range) => range.isChecked).map((range) => range.id);
            } else return [];
        },
        getFilterLabel: function (filter) {
            let filterLabel = filter.label
            if (filter.mobilesCount !== null && filter.mobilesCount !== undefined) {
                filterLabel += ' (' + filter.mobilesCount + ')'
            }
            return filterLabel
        },
        sortMobilesSelected(sortId) {
            Tms.link({category: "selecteur_produit", action: sortId, label: "trier_par"});
            let selectedSort = this.sortRadioButtons.find(sort => sort.radioButtonDTO.id === sortId)
            if (selectedSort) {
                this.$emit('sort-item-click', selectedSort.radioButtonDTO.value);
            }
        },
        statusMobilesSelected(statusId) {
            Tms.link({category: "selecteur_produit", action: statusId, label: "etat"});
            let selectedStatus = this.statusRadioButtons.find(status => status.radioButtonDTO.id === statusId)
            if (selectedStatus) {
                this.$emit('status-item-click', selectedStatus.radioButtonDTO.value);
            }
        },
        brandCollapsedTitle() {
            this.brandCollapseTitle = "Moins de marques"
        },
        brandNotCollapsedTitle() {
            this.brandCollapseTitle = "Plus de marques"
        },
        refurbishedBrandCollapsedTitle() {
            this.refurbishedBrandCollapseTitle = "Moins de marques"
        },
        refurbishedBrandNotCollapsedTitle() {
            this.refurbishedBrandCollapseTitle = "Plus de marques"
        }
    },
}
</script>

<template>
    <div id="selector-filters" class="pt-1">
        <div class="d-webview-none">
            <div class="d-flex">
                <equipment-search-field
                    v-if="searchFiltersDto"
                    class="me-2 w-100"
                    :place-holder="searchFiltersDto.cartBannerSearchLabel"
                    :search-results-url="searchFiltersDto.searchResultsUrl"
                    :search-results-query-additional-params="searchFiltersDto.searchResultsQueryAdditionalParams"
                    :algolia-api-key="searchFiltersDto.algoliaDto.apiKey"
                    :algolia-app-id="searchFiltersDto.algoliaDto.appId"
                    :algolia-index-name="searchFiltersDto.algoliaDto.indexName"
                />
            </div>
            <hr v-if="searchFiltersDto" class="separator separator--gray4 mb-1 mt-1">
        </div>
        <div class="fw-bold mt-1">
            Trier par
        </div>
        <ob1-radio-button-list
            class="ms-1"
            :radios-buttons="sortRadioButtons"
            @change="sortMobilesSelected"
        />
        <div v-if="filtersSegments && filtersSegments.checkboxes.length > 0">
            <hr class="separator separator--gray4 mb-2 mt-1">
            <div class="fw-bold my-1">
                {{ filtersSegments.label }}
            </div>
            <div v-for="filter in filtersSegments.checkboxes" :key="filter.filterId" class="ms-1">
                <ob1-check-box2
                    :id="'checkbox-'+filter.filterId"
                    v-model="filter.isChecked"
                    :name="'segments'"
                    :label="getFilterLabel(filter)"
                    :is-indeterminated="filter.isIndeterminated"
                    @change="filterHandler(filtersSegments.label, filter.label, filter.isChecked)"
                />
            </div>
        </div>
        <div v-if="filtersBonusRecovery">
            <hr class="separator separator--gray4 my-2">
            <div class="fw-bold my-1">
                {{ filtersBonusRecovery.label }}
            </div>
            <div v-for="filter in filtersBonusRecovery.checkboxes" :key="filter.filterId" class="ms-1">
                <ob1-check-box2
                    :id="'checkbox-'+filter.filterId"
                    v-model="filter.isChecked"
                    :name="'bonus-recovery'"
                    :label="getFilterLabel(filter)"
                    :is-indeterminated="filter.isIndeterminated"
                    @change="filterHandler(filtersBonusRecovery.label, filter.label, filter.isChecked)"
                />
                <template v-if="filter.isChecked">
                    <div
                        v-for="range in filter.ranges"
                        :key="range.id"
                        class="ms-1"
                    >
                        <ob1-check-box2
                            :id="range.id"
                            v-model="range.isChecked"
                            :name="range.id"
                            :label="getFilterLabel(range)"
                            @change="filterHandler(filtersBonusRecovery.label, range.label, range.isChecked)"
                        />
                    </div>
                </template>
            </div>
        </div>
        <div v-if="filtersPrice">
            <hr class="separator separator--gray4 my-2">
            <div class="fw-bold my-1">
                {{ filtersPrice.label }}
            </div>
            <div v-for="filter in filtersPrice.checkboxes" :key="filter.filterId" class="ms-1">
                <ob1-check-box2
                    :id="'checkbox-'+filter.filterId"
                    v-model="filter.isChecked"
                    :name="'prices'"
                    :label="getFilterLabel(filter)"
                    :is-indeterminated="filter.isIndeterminated"
                    @change="filterHandler(filtersPrice.label, filter.label, filter.isChecked)"
                />
            </div>
        </div>
        <hr class="separator separator--gray4 my-2">
        <div class="fw-bold mt-1" v-html="stateLabel" />
        <ob1-radio-button-list
            class="ms-1"
            :radios-buttons="statusRadioButtons"
            @change="statusMobilesSelected"
        />
        <template v-if="filtersBrand && brandsWithMobiles.length > 0">
            <div v-show="showBrandsFilter">
                <hr class="separator separator--gray4 my-2">
                <div class="fw-bold my-1">
                    {{ filtersBrand.label }}
                </div>
                <div v-for="filter in brandsWithNotCollapse" :key="filter.filterId" class="ms-1">
                    <ob1-check-box2
                        :id="'checkbox-'+filter.filterId"
                        v-model="filter.isChecked"
                        :name="'brands'"
                        :label="getFilterLabel(filter)"
                        :is-indeterminated="filter.isIndeterminated"
                        @change="filterHandler(filtersBrand.label, filter.label, filter.isChecked)"
                    />
                    <template v-if="filter.isChecked">
                        <div
                            v-for="range in filter.ranges"
                            :key="range.id"
                            class="ms-1"
                        >
                            <ob1-check-box2
                                :id="range.id"
                                v-model="range.isChecked"
                                :name="range.id"
                                :label="range.label"
                                @change="filterHandler(filtersBrand.label, filter.label + '_' + range.label, range.isChecked)"
                            />
                        </div>
                    </template>
                </div>
                <ob1-liens-haut-bas
                    v-if="brandsWithCollapse.length > 0"
                    button-id="collapsed-brand-header"
                    :button-label="brandCollapseTitle"
                    :with-link-bottom="true"
                    collapsed-block-id="brand-collapsed-block"
                    @ob1-liens-haut-bas-show-block="brandCollapsedTitle"
                    @ob1-liens-haut-bas-hide-block="brandNotCollapsedTitle"
                >
                    <div v-for="filter in brandsWithCollapse" :key="filter.filterId" class="ms-1">
                        <ob1-check-box2
                            :id="'checkbox-'+filter.filterId"
                            v-model="filter.isChecked"
                            :name="'brands'"
                            :label="getFilterLabel(filter)"
                            :is-indeterminated="filter.isIndeterminated"
                            @change="filterHandler(filtersBrand.label, filter.label, filter.isChecked)"
                        />
                        <template v-if="filter.isChecked">
                            <div
                                v-for="range in filter.ranges"
                                :key="range.id"
                                class="ms-1"
                            >
                                <ob1-check-box2
                                    :id="range.id"
                                    v-model="range.isChecked"
                                    :name="range.id"
                                    :label="range.label"
                                    @change="filterHandler(filtersBrand.label, filter.label + '_' + range.label, range.isChecked)"
                                />
                            </div>
                        </template>
                    </div>
                </ob1-liens-haut-bas>
            </div>
        </template>
        <template v-if="filtersRefurbishedBrand && refurbishedBrandsWithMobiles.length > 0">
            <div v-show="showRefurbishedBrandsFilter">
                <hr class="separator separator--gray4 my-2">
                <div class="fw-bold my-1">
                    {{ filtersRefurbishedBrand.label }}
                </div>
                <div v-for="filter in refurbishedBrandsWithNotCollapse" :key="filter.filterId" class="ms-1">
                    <ob1-check-box2
                        :id="'checkbox-'+filter.filterId"
                        v-model="filter.isChecked"
                        :name="'refurbishedbrands'"
                        :label="getFilterLabel(filter)"
                        :is-indeterminated="filter.isIndeterminated"
                        @change="filterHandler(filtersRefurbishedBrand.label, filter.label, filter.isChecked)"
                    />
                    <template v-if="filter.isChecked">
                        <div
                            v-for="range in filter.ranges"
                            :key="range.id"
                            class="ms-1"
                        >
                            <ob1-check-box2
                                :id="range.id"
                                v-model="range.isChecked"
                                :name="range.id"
                                :label="range.label"
                                @change="filterHandler(filtersRefurbishedBrand.label, filter.label + '_' + range.label, range.isChecked)"
                            />
                        </div>
                    </template>
                </div>
                <ob1-liens-haut-bas
                    v-if="refurbishedBrandsWithCollapse.length > 0"
                    button-id="collapsed-refurbished-brand-header"
                    :button-label="refurbishedBrandCollapseTitle"
                    :with-link-bottom="true"
                    collapsed-block-id="refurbished-brand-collapsed-block"
                    @ob1-liens-haut-bas-show-block="refurbishedBrandCollapsedTitle"
                    @ob1-liens-haut-bas-hide-block="refurbishedBrandNotCollapsedTitle"
                >
                    <div v-for="filter in refurbishedBrandsWithCollapse" :key="filter.filterId" class="ms-1">
                        <ob1-check-box2
                            :id="'checkbox-'+filter.filterId"
                            v-model="filter.isChecked"
                            :name="'refurbishedbrands'"
                            :label="getFilterLabel(filter)"
                            :is-indeterminated="filter.isIndeterminated"
                            @change="filterHandler(filtersRefurbishedBrand.label, filter.label, filter.isChecked)"
                        />
                        <template v-if="filter.isChecked">
                            <div
                                v-for="range in filter.ranges"
                                :key="range.id"
                                class="ms-1"
                            >
                                <ob1-check-box2
                                    :id="range.id"
                                    v-model="range.isChecked"
                                    :name="range.id"
                                    :label="range.label"
                                    @change="filterHandler(filtersRefurbishedBrand.label, filter.label + '_' + range.label, range.isChecked)"
                                />
                            </div>
                        </template>
                    </div>
                </ob1-liens-haut-bas>
            </div>
        </template>
        <div v-if="filtersRefurbishedSegments && filtersRefurbishedSegments.checkboxes.length > 0">
            <hr class="separator separator--gray4 mb-2 mt-1">
            <div class="fw-bold my-1">
                {{ filtersRefurbishedSegments.label }}
            </div>
            <div v-for="filter in filtersRefurbishedSegments.checkboxes" :key="filter.filterId" class="ms-1">
                <ob1-check-box2
                    :id="'checkbox-'+filter.filterId"
                    v-model="filter.isChecked"
                    :name="'segments'"
                    :label="getFilterLabel(filter)"
                    :is-indeterminated="filter.isIndeterminated"
                    @change="filterHandler(filtersRefurbishedSegments.label, filter.label, filter.isChecked)"
                />
            </div>
        </div>
        <div v-if="filtersRepairability">
            <hr class="separator separator--gray4 my-2">
            <div class="fw-bold my-1">
                <div class="ob1-tooltip d-flex flex-column">
                    <a href="#" class="ob1-tooltip-trigger" aria-describedby="tooltip-content-left">
                        <u v-html="filtersRepairability.label" />
                    </a>
                    <div id="tooltip-content-left" class="ob1-tooltip-content ob1-tooltip-left">
                        <p v-html="filtersRepairability.tooltip" />
                    </div>
                    <div class="ob1-tooltip-shadow" />
                </div>
                <span v-html="filtersRepairability.note" />
            </div>
            <div v-for="filter in filtersRepairability.checkboxes" :key="filter.filterId" class="ms-1">
                <ob1-check-box2
                    :id="'checkbox-'+filter.filterId"
                    v-model="filter.isChecked"
                    :name="'prices'"
                    :label="getFilterLabel(filter)"
                    :is-indeterminated="filter.isIndeterminated"
                    @change="filterHandler(filtersRepairability.label, filter.label, filter.isChecked)"
                />
            </div>
        </div>
        <div v-if="filtersCompatibility">
            <hr class="separator separator--gray4 my-2">
            <div class="fw-bold my-1">
                {{ filtersCompatibility.label }}
            </div>
            <div v-for="filter in filtersCompatibility.checkboxes" :key="filter.filterId" class="ms-1">
                <ob1-check-box2
                    :id="'checkbox-'+filter.filterId"
                    v-model="filter.isChecked"
                    :name="'compatibilities'"
                    :label="getFilterLabel(filter)"
                    :is-indeterminated="filter.isIndeterminated"
                    @change="filterHandler(filtersCompatibility.label, filter.label, filter.isChecked)"
                />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@media (max-width: 735px) {
    .ob1-tooltip:hover .ob1-tooltip-content.ob1-tooltip-left {
        top: 75%;
    }
}
</style>
